import { Button } from '@components/button';
import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { StaffUser } from '@root/globalTypes';
import { UseMutateFunction } from '@tanstack/react-query';
import { Mail } from 'lucide-react';

type ResendInvitationBtnProps = {
  user: StaffUser;
  onResend: UseMutateFunction<{ message: string }, Error, string, unknown>;
};

export function ResendStaffUserInvitationButton({ user, onResend }: ResendInvitationBtnProps) {
  const { verifyUserPermission } = useCheckUserPermissions();

  if (
    !verifyUserPermission(`staff_users_update`) ||
    !user.invitationSentAt ||
    user.invitationAcceptedAt
  ) {
    return null;
  }

  return (
    <Button
      size="sm"
      className="w-14"
      variant="outline"
      type="button"
      onClick={() => onResend(user.id)}>
      <Mail className="h-5" />
    </Button>
  );
}
